export default __webpack_public_path__ + "static/media/h9.328ef2b2.jpg";